import { Component, inject, input } from '@angular/core';
import { SeatDefinition } from '@core/models';
import { BrnDialogRef } from '@spartan-ng/brain/dialog';

@Component({
  standalone: false,
  selector: 'app-seat-definitions-modal',
  templateUrl: './seat-definitions-modal.component.html',
  styleUrl: './seat-definitions-modal.component.css',
})
export class SeatDefinitionsModalComponent {
  readonly definitions = input<SeatDefinition[]>([]);
  readonly isAda = input<boolean>(false);
  readonly seatId = input<string>('');
  readonly title = input<string>('Seat Definitions');

  private dialogRef = inject(BrnDialogRef);

  close() {
    this.dialogRef.close();
  }

  get seatSection() {
    const id = this.seatId();
    return id.split('-')[0].split('_')[1];
  }

  get seatRow() {
    return this.seatId().split('-')[1];
  }

  get seat() {
    return this.seatId().split('-')[2];
  }
}
